import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputFormTextField from 'components/atoms/GefMui/OutputFormTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import formDescriptorFn, {
	CONSULTANT_INFO_FORM_NAME,
	FIELDS,
} from 'features/views/productionControlDetail/consultantInfo/form';
import { getProductionControlDetail } from 'features/views/productionControlDetail/selectors';

export const ConsultatntInfo = () => {
	const productionControlDetail = useSelector(getProductionControlDetail);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('productionControlDetail:consultantInfo')} />
				<Form name={CONSULTANT_INFO_FORM_NAME} formDescriptorFn={formDescriptorFn}>
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={2}>
								<Grid size={6}>
									<OutputFormTextField
										size="small"
										fieldName={FIELDS.solverName}
										label={getLabelMessage('productionControlDetail:solverName')}
										fullWidth
										value={productionControlDetail?.solverName}
										slotProps={{
											inputLabel: {
												shrink: !!productionControlDetail?.solverName,
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputFormTextField
										size="small"
										fieldName={FIELDS.solverSellerIn}
										label={getLabelMessage('productionControlDetail:solverSellerIn')}
										fullWidth
										value={productionControlDetail?.solverSellerNumber}
										slotProps={{
											inputLabel: {
												shrink: !!productionControlDetail?.solverSellerNumber,
											},
										}}
									/>
								</Grid>
								<Grid size={12}>
									<OutputFormTextField
										size="small"
										fieldName={FIELDS.superiorName}
										label={getLabelMessage('productionControlDetail:superiorName')}
										fullWidth
										value={productionControlDetail?.superiorName}
										slotProps={{
											inputLabel: {
												shrink: !!productionControlDetail?.superiorName,
											},
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Form>
			</Stack>
		</Paper>
	);
};

export default ConsultatntInfo;
